import { render, staticRenderFns } from "./AuctionPostFormComponent.vue?vue&type=template&id=0fea4336&scoped=true&"
import script from "./AuctionPostFormComponent.vue?vue&type=script&lang=ts&"
export * from "./AuctionPostFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionPostFormComponent.vue?vue&type=style&index=0&id=0fea4336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea4336",
  null
  
)

export default component.exports